<template>
    <div style="font-size:16px; color: #666; font-family: 'Microsoft YaHei';">
        <div id="indextop" class="h66">
            <div class="pa20 l">
                <div id="logo" width="98" height="40"></div>
            </div>
            <div class="nav r " style="line-height: 80px;">
                <ul id="ebadu_nav">
                    <li class="l p30 "><a class="top_a" href="/">首页</a></li>
                    <li class="l p30 "><a class="top_b drop-down " _t_nav="product" target="_blank" href="/productintroduction">产品中心</a>                    
                    </li>
                    <li class="l p30 "><a class="top_b " _t_nav="solution" href="/feeindex" target="_blank">资费说明</a></li>
                    <li class="l p30 "><a class="top_b " _t_nav="cooperate" href="/kefu" target="_blank">客服中心</a></li>
                    <li class="l p30 "><a class="top_b " _t_nav="cooperate" target="_blank" href="/aboutus">关于我们</a></li>
                    <li class="l p30 "><a class="top_b " _t_nav="cooperate" href="#">客户端</a></li>
                </ul>
            </div>
        </div>

        
        <div id="banner_tabs" class="flexslider">
            <ul class="slides">                
                <li id="bgImg1" style="display: block;">
                    <div class="bg_img1"></div>
                </li>
                <li id="bgImg2" style="display: none;">
                    <div class="bg_img2"></div>
                </li>
                <li id="bgImg3" style="display: none;">
                    <div class="bg_img3"></div>
                </li>
            </ul>
            <ol class="flex-control-nav flex-control-paging">
                <li>
                    <div id="flex1" @click="showImg(1)" class="bg_flex1"></div>
                </li>
                <li>
                    <div id="flex2" @click="showImg(2)" class="bg_flex2"></div>
                </li>
                <li>
                    <div id="flex3" @click="showImg(3)" class="bg_flex2"></div>
                </li>
            </ol>

            <!-- <ul style="position: absolute;width: 100%; top: 45%; z-index: 11;">
                <li style="position:absolute; width:50px; height:50px; z-index:1; left: 17px; "><div class="flex-prev" @click="prev" ></div></li>
                <li style="position:absolute; width:50px; height:50px; z-index:2; left: 95%;"><div class="flex-next" @click="next"></div></li>
            </ul> -->
        </div>
        

        <div id="loginhomepage">
            <div class="w1100">
                <div class="w340 h408 bfff mt84 mr35 r">
                <ul class="m30">
                    <li class="h40 w280">
                    <div class="l  c333  f20">登录</div>
                    </li>
                    <li class="w280 h58"><input  class="h36 w248 plr15 f14 tal  br2" v-model="loginName" id="email" type="text" placeholder="门牌号/手机号/邮箱" /></li>
                    <li class="w280 h58">
                    <input class="h36 w248 plr15 tal f14 mpt20 br2"  v-model="loginPwd" type="password" placeholder="登录密码"/></li>
                    <li class="h36 w280  ">
                    <div >
                    <input class="w120 h36 tal f14 l plr15  br2" v-model="loginCode" type="text" placeholder="验证码" />
                    </div>
                    <div class="l ml10">
                        <div class="code" @click="refreshCode">
                            <s-identify :identifyCode="identifyCode"></s-identify>
                        </div>
                    </div>
                    </li>
                    <li class="w280 mt20">
                        <button  class="h36 w280  plr15 f18 dlan" v-on:click="login">登 录</button>                
                    </li>            
                    <li class="w280 h36 f14 mb10"><div class="r"><a href="/reg" target="_blank" class="c333">免费注册</a>
                    &nbsp;&nbsp;
                    <a  class="c333" href="/getpassword">忘记密码</a></div></li>
                    <li class="h36 w280 f14 brt1">
                    <div class="l">快速登录：</div>
                    <div class="l mt10 ml10"> <button  class="weibo"></button></div>
                    <div class="l mt10 ml10"> <button  class="qq" @click="qqlogin()"></button></div>
                    <div class="l mt10 ml10"> <button  class="zfb1" @click="alipaylogin()"></button></div>
                    
                    
                    </li>
                </ul>
                </div>
            </div>
        </div>

        
        <div id="broadcast">
            <div class="broadcast_a">
            <ul>
            <li class="br l "></li>
            <li class="l c333 f16">公司最新公告</li>      
            <li class="l "><span class="br_a f16">NEW</span></li>
            <li class=" l f16">2019我们有最新的功能上线了</li>
            </ul>
            </div>
        </div>
        
        <div id="product_a">
            <h1 class="title_1">我们的产品</h1>
            <h2 class="title_2">国内领先、安全、快速、稳定的产品</h2>
            <div class="product_z">
                <ul class="w252 l">
                    <li class="dx_i"></li>
                    <li class="f20">短信低资费</li>
                    <li class="f16">0.04元/条起</li>
                    <li class="f16"><a class="pt_bt c198ede" href="#">立即注册</a></li>
                </ul>
                <ul class=" w252 l">
                    <li class="dx_4"></li>
                    <li class="f20">400电话办理</li>
                    <li class="f16">360元/年</li>
                    <li class="f16"><a class="pt_bt c198ede" href="#">立即咨询</a></li>
                </ul>
                <ul class=" w252 l">
                    <li class="dx_r"></li>
                    <li class="f20">商标注册</li>
                    <li class="f16">499元/件</li>
                    <li class="f16"><a class="pt_bt c198ede" href="#">立即咨询</a></li>
                </ul>
            </div>
        </div>
        
        <div id="api">
            <div class="w1100">
                <h1 class="title_1">API接口 轻松接入</h1> 
                <div class="api_a">
                    <div class="w550 l">
                        <ul>
                            <li class="bg_2">
                                <h3 class="te_a title_3">短信API</h3>
                                <p class="te_a f16 lh28 ">为第三方用户提供了短信下行、余额查询、上行短信接收和已读标志的置换、主动推送获取的上行短信和下行短信的状态<br/></p>
                                <div class="te_a m15"><a class="api_bt" href="#" target="_blank">立即申请</a></div>
                            </li>
                            <li class="bg_2">
                                <h3 class="te_a title_3">电话API</h3>
                                <p class="te_a f16 lh28 ">提供了点击通话（主要指两方通话）的功能<br/></p>
                                <div class="te_a m15"><a class="api_bt" href="#" target="_blank">立即申请</a></div>
                            </li>
                            <li class="bg_2">
                                <h3 class="te_a title_3">语音验证API</h3>
                                <p class="te_a f16 lh28 ">提供了语音短信或语音验的功能<br/></p>
                                <div class="te_a m15"><a class="api_bt" href="#" target="_blank">立即申请</a></div>
                            </li>
                        </ul>
                    </div>
                    <div class="w550 r">
                        <ul>
                            <li class="bg_2">
                                <h3 class="te_a title_3">传真API</h3>
                                <p class="te_a f16 lh28 ">提供发送传真, 以及获取传真发送结果<br/></p>
                                <dd class="te_a m15"><a class="api_bt" href="#" target="_blank">立即申请</a></dd>
                            </li>
                            <li class="bg_2">
                                <h3 class="te_a title_3">会议API</h3>
                                <p class="te_a f16 lh28 ">提供了用户发起会议、追加会议以及查询历史会议的功能<br/></p>
                                <div class="te_a m15"><a class="api_bt" href="#" target="_blank">立即申请</a></div>
                            </li>
                            <li class="bg_2">
                                <h3 class="te_a title_3">邮件API</h3>
                                <p class="te_a f16 lh28 ">发送邮件<br/></p>
                                <div class="te_a m15"><a class="api_bt" href="#" target="_blank">立即申请</a></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="product_a">
            <h1 class="title_1">400电话/流量</h1>
            <h2 class="title_2">以移动、联通、电信三大运营商流量作为合作资源</h2>
            <div class="product_z">
                <ul class="w246 l">
                    <li class="dh_a"></li>
                    <li class="f20 p02">快速办理400业务</li>
                    <li class="f14"><a class="pt_bta d83d39" href="#">立即注册</a></li>
                </ul>
                    <ul class="w246 l">
                    <li class="dh_b"></li>
                    <li class="f20 p02">400套餐详情</li>
                    <li class="f14"><a class="pt_bta d83d39" href="#">立即注册</a></li>
                </ul>
                    <ul class="w246 l">
                    <li class="dh_c"></li>
                    <li class="f20 p02">400秒杀价</li>
                    <li class="f14"><a class="pt_bta d83d39" href="#">立即注册</a></li>
                </ul>
                    <ul class="w246 l">
                    <li class="dh_d"></li>
                    <li class="f20 p02">三网流量包</li>
                    <li class="f14"><a class="pt_bta d83d39" href="#">立即注册</a></li>
                </ul>
                
            </div>
        </div>
        

        <div id="brand">
            <div class="w1100">
                <h1 class="title_4">商标注册 ￥599起</h1>
                <h2 class="title_5">帮您一站是完成所有复杂程序，专人负责跟踪</h2>
                <div class="zc">
                    <button class="zc"></button>
                
                </div>
                <div style=" padding-left:200px; padding-top:30px;">
                    <ul class="abc7ff l m10">
                    <li class=" zc_a"></li>
                    <li class="p10 f20">注册成功案例</li>
                    <li class="p10 "> <a class="pt_btb abc7ff" href="#">查看详情</a></li>
                    </ul>
                    <ul class="abc7ff l m10">
                    <li class=" zc_b"></li>
                    <li class="p10 f20">商标分类</li>
                    <li class="p10 "> <a class="pt_btb abc7ff" href="#">查看详情</a></li>
                    </ul>
                    <ul class="abc7ff l m10">
                    <li class=" zc_c"></li>
                    <li class="p10 f20">商标代设计</li>
                    <li class="p10 "> <a class="pt_btb abc7ff" href="#">查看详情</a></li>
                    </ul>
                </div>
            </div>
        </div>

        
        <div id="wyzc">
        <h1 class="title_1">通用接口，快速稳定</h1>
        <h2 class="title_2 p10">支持多种主流语言  三网合一     短信价格<span class="cf06000 f24">0.04元/条起</span></h2>
        <div  class="m50"><a class="wyzca" href="#">注册试用 </a></div>
        </div>
        
        <div id="bottom" class="ba161d28">
            <div class="bp40 w690 p18">
                <a class="botz1" href="user_2office" target="_blank">用户协议</a>
                | 
                <a class="botz1" href="aboutus" target="_blank">关于我们</a>
                | 
                <a class="botz1" href="job_2office" target="_blank">人才招聘</a>
                | 
                <a class="botz1" href="dailihezuo" target="_blank">代理合作</a>
            </div>
            <div class="w690 bp30">
                <div class="l">
                    <ul>
                        <li class="zfb">
                        </li>
                        <li class="f20 p10">
                        支付宝特邀商家
                        </li>
                    </ul>
                </div>
                <div class="r te_a lh35">
                    Copyright 2006-2019 第二办公室 www.2office.cn<br/>
                    杭州快鱼科技有限公司 
                    <a href="https://beian.miit.gov.cn/" style="color: rgb(102, 102, 102);font-size:9pt;line-height: 35px;" target="_blank">浙ICP备09072632号</a> 
                    <a href="https://beian.miit.gov.cn/" style="color: rgb(102, 102, 102);font-size:9pt;line-height: 35px;" target="_blank">浙B2-2010426</a> 
                    <a href="https://beian.miit.gov.cn/" style="color: rgb(102, 102, 102);font-size:9pt;line-height: 35px;" target="_blank">浙ICP备09072632号-1</a><br/>
                    <a href="https://beian.miit.gov.cn/" style="color: rgb(102, 102, 102);font-size:9pt;line-height: 35px;" target="_blank">浙公网安备 33010602002226号</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="//www.cnzz.com/stat/website.php?web_id=2117569" target="_blank">
                        <img src="//icon.cnzz.com/img/pic.gif" />
                    </a>
                </div>
            </div>
        </div>

        <div id="kefu">
            <div class="kef">
                <button class="kef" @click="talkkefu()"></button>
            </div>
            <div class="kef2">
                <button class="kef2" @click="open400()"></button>
            </div>
            <div id="to_top" class="to_top">
                <button class="to_top" @click="to_top()"></button>
            </div>
        </div>
    </div>    
</template>
<script>
import '../assets/css/index.css'; /*引入公共样式*/
import crypto from 'crypto'
import {setCookie,getCookie} from '../assets/js/cookie.js'
var scrollingInterval;
export default {
    data(){
        return{
            msg:'',//密码输入错误请重新输入
            loginName:'',
            loginPwd:'',
            identifyCodes: "1234567890",
            identifyCode: "",
            loginCode: '',
            imgIndex:1,
        }
    },
    mounted() {
        if (window != top){
            top.location.href = location.href;
        }
        this.makeCode(this.identifyCodes, 4);
        scrollingInterval = setInterval(this.autoshow,5000);
    },
    destroyed:function(){
        clearInterval(scrollingInterval);
    },
    methods:{
        login(){
            var that = this;
            if(this.loginName == ""){
                alert("请输入账号")
                return
            }
            if(this.loginPwd == ""){
                alert("请输入密码")
                return
            }
            if(this.loginCode != this.identifyCode){
                alert("验证码不正确")
                return
            }
            var password = this.$options.methods.getmd5(this.$options.methods.getmd5(this.loginPwd)+this.loginName)
            let data = {'loginName':this.loginName,'loginPwd':password,'loginSource':'web'}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/login/login.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                // console.log(JSON.stringify(res.data))
                if('0000000' == res.data.code)
                {
                    that.GLOBAL.token = res.data.token
                    setCookie('2officesessionid',res.data.token,60*60*10)
                    that.$router.push('/main')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getmd5(str){
            var a;
            var md5 = crypto.createHash("md5");
            md5.update(str);
            var a = md5.digest('hex');
            return a;
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                    this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        qqlogin(){
            location.href = "qqlogin";
        },
        alipaylogin(){
            location.href = "alipayauth"
        },
        user2office() {
            window.open('user_2office', 'blank');
        },
        aboutus() {
            window.open('aboutus', 'blank');
        },
        talkkefu() {
            //window.open('//wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDAyMDIxNF80ODkyNjJfODAwMDIwMjE0XzJf');
            window.open('tencent://message/?uin=2040399162&Site=http://vps.shuidazhe.com&Menu=yes');
        },
        to_top() {
            location.href = "#";
        },
        open400() {
            window.open('https://4006.2office.cn/lkszjreo/wqi4rpo/ewirwed/qncyrq/oijoijfkiej.aspx', '800', '600');
        },
        prev(){
            this.imgIndex = this.imgIndex - 1;
            if(this.imgIndex <= 0)
            {
                this.imgIndex = 3;
            }
            this.showImg(this.imgIndex);
            
        },
        next(){
            this.imgIndex = this.imgIndex + 1;
            if(this.imgIndex > 3)
            {
                this.imgIndex = 1;
            }
            this.showImg(this.imgIndex);
        },
        showImg(index){
            this.imgIndex = index;
            for(let i = 1; i <= 3; i++)
            {
                if(i == index)
                {
                    document.getElementById("bgImg" + i).style.display = "block";
                    document.getElementById("flex" + i).className="bg_flex1";
                }
                else
                {
                    document.getElementById("bgImg" + i).style.display = "none";
                    document.getElementById("flex" + i).className="bg_flex2";
                }
            }

        },
        showImg2(){
            console.log('showImg2');
        },
        autoshow()
        {
            if( this.imgIndex >= 3)
            {
                this.imgIndex = 1;
            }
            else
            {
                this.imgIndex = this.imgIndex + 1;
            }
            
            this.showImg(this.imgIndex);
        }
    }
}
</script>

<style>
.bg_img1 {
    /* width: 1924px; */
    height: 500px;
    background: url('../assets/images/Carousel_5.jpg') center center no-repeat;
    /* background-position: center center; */
}
.bg_img2 {
    /* width: 1924px; */
    height: 500px;
    background: url('../assets/images/Carousel_6.jpg') center center no-repeat;
    /* background-position: center center; */
}
.bg_img3 {
    /* width: 1924px; */
    height: 500px;
    background: url('../assets/images/Carousel_7.jpg') center center no-repeat;
    /* background-position: center center; */
}

.bg_flex1{
    height: 18px;
    width: 18px;
    background: url('../assets/images/dot3.png') center center no-repeat;
    z-index: 20;
    cursor: pointer;
}
.bg_flex2{
    height: 18px;
    width: 18px;
    background: url('../assets/images/dot4.png') center center no-repeat;
    cursor: pointer;
}
 .flex-prev{
    /* left: 40px; */
    height: 50px;
    background: url('../assets/images/prev.png') no-repeat;
    cursor: pointer;
}
.flex-next{
    /* right: 140px; */
    height: 50px;
    background: url('../assets/images/next.png') no-repeat;
    cursor: pointer;
}

.flex-direction-nav {
    position: absolute;
    width: 100%;
    top: 45%;
    z-index: 11;
    /* list-style: none; padding: 0px; margin: 0px; position: relative; */
    /* position: relative; */
}


/* {
    font-family: "微软雅黑";
    font-family: "Microsoft YaHei";
    color: #666;
    font-size: 16px;
} */
</style>


// WEBPACK FOOTER //
// src/components/index.vue